import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  popup: {
    display: false,
    id: ''
  },
  create_account_popup: false,
  account: {},
  countries: [],
  communication_methods: [],
  member_accounts: [],
  acceptedAccounts: [],
  industries: [],
  managers: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
